var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12",staticStyle:{"padding-left":"0px","padding-right":"0px"}},[_c('left-nav'),_c('div',{attrs:{"id":"appContainer"}},[_c('app-content')],1)],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }